"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledStepper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledStepper = _styledComponents.default.div.withConfig({
  displayName: "Stepperstyles__StyledStepper",
  componentId: "ln0i9j-0"
})(["display:flex;flex-flow:column nowrap;justify-content:center;align-content:center;align-items:center;.c-stepper-label{font-weight:", ";}.c-stepper-controls-wrapper{display:flex;flex-flow:row nowrap;justify-content:center;align-content:center;align-items:center;}.c-stepper-value-display{padding:", ";color:", ";min-width:3rem;font-weight:", ";font-size:", ";text-align:center;user-select:none;}"], function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.primaryHeavy;
}, function (props) {
  return props.theme.fontMedium;
});

exports.StyledStepper = StyledStepper;